window.$ = window.jQuery = require('jquery');
require('./plugins/jquery.selectbox-0.2.js');
require('./plugins/easyResponsiveTabs.js');
require('./plugins/jquery.sticky.js');

require('./pages/home.js');
require('./plugins/common');


require('./plugins-v4/jquery.mmenu.min.all');
require('./plugins-v4/ddsmoothmenu');
require('./plugins-v4/common');
